<app-header [progress]="2" [title]="locale.currentTranslation.accidentDescriptionHeader" data-testid="user-participation-header"></app-header>
<div class="base-content-container" data-testid="user-participation-container">
  <div class="headline3" data-testid="user-participation-title">{{ locale.currentTranslation.userParticipationIdentification1 }}</div>
  <div style="display: flex; flex-direction: column; gap: 24px;" data-testid="radio-options">
    <div class="radio-button-base" data-testid="radio-option-driver">
      <div>
        <input (change)="onSelectionChange(true)"
          [(ngModel)]="isDriver"
          [value]="true"
          name="booleanGroup"
          type="radio"
          data-testid="radio-input-driver"
          aria-labelledby="driver-label">
      </div>
      <div (click)="onSelectionChange(true)" data-testid="radio-label-container-driver">
        <div class="label1" id="driver-label" data-testid="radio-headline-driver">{{ locale.currentTranslation.userParticipationIdentificationOptionHeadline1 }}</div>
        <div class="caption1" data-testid="radio-caption-driver">{{ locale.currentTranslation.userParticipationIdentificationOptionCaption1 }}</div>
      </div>
    </div>
    <div class="radio-button-base" data-testid="radio-option-passenger">
      <div>
        <input (change)="onSelectionChange(false)"
          [(ngModel)]="isDriver"
          [value]="false"
          name="booleanGroup"
          type="radio"
          data-testid="radio-input-passenger"
          aria-labelledby="passenger-label">
      </div>
      <div (click)="onSelectionChange(false)" data-testid="radio-label-container-passenger">
        <div class="label1" id="passenger-label" data-testid="radio-headline-passenger">{{ locale.currentTranslation.userParticipationIdentificationOptionHeadline2 }}</div>
        <div class="caption1" data-testid="radio-caption-passenger">{{ locale.currentTranslation.userParticipationIdentificationOptionCaption2 }}</div>
      </div>
    </div>
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotChosen }}
    </div>
  }
  <div class="divider">
  </div>
  <button (click)="showAdditionalInformation = !showAdditionalInformation"
    class="button-as-div"
    data-testid="additional-info-toggle"
    type="button">
    <img height="20" ngSrc="assets/img/info-icon.svg" width="20">
    <div class="label2">
      {{ locale.currentTranslation.additionInformation }}
    </div>
    <img [ngSrc]="showAdditionalInformation ? 'assets/img/up-carret.svg' : 'assets/img/down-carret.svg'" height="20"
      width="20">
  </button>
  @if (showAdditionalInformation) {
    <div data-testid="additional-info-content">
      <div class="text-body1">
        <span>{{ locale.currentTranslation.userParticipationIdentification2 }}</span>
      </div>
      <div class="text-body1">
        <span>{{ locale.currentTranslation.userParticipationIdentification3 }}</span>
      </div>
      <div class="card-additional-information" style="margin-top: 20px;">
        <div style="display: flex; align-items: center; gap: 8px;">
          <img height="20" ngSrc="assets/img/info-icon.svg" width="20">
          <div class="headline4">
            {{ locale.currentTranslation.important }}
          </div>
        </div>
        <div class="text-body2">
          <span>
            {{ locale.currentTranslation.userParticipationIdentification4 }}
          </span>
          <div style="margin-top: 20px;">
            <span>
              {{ locale.currentTranslation.userParticipationIdentification5 }}
            </span>
            <div>
              {{ locale.currentTranslation.userParticipationIdentification6 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<div class="main-button-spacing">
  <button (click)="nextClicked()" class="main-button" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="user-participation-footer"></app-footer>
